export default __webpack_public_path__ + "8912617e4259ff96215026b76d59b37b.webp";